// extracted by mini-css-extract-plugin
module.exports = {"spacer":"confirm-dialog_spacer__24hRG","confirmCancelButtonsContainer":"confirm-dialog_confirmCancelButtonsContainer__3F48x"};